import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCartApprovedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 152,
	viewBox: "0 0 200 152",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5242_35467)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M88.2848 119.427L34.1679 135.227C33.7619 135.347 33.3446 135.407 32.9284 135.407C32.2773 135.407 31.6289 135.261 31.0306 134.973C30.0471 134.499 29.2813 133.68 28.874 132.668L28.8169 132.506L18.7736 99.8079L3.42718 104.288L0.978516 95.901L20.2772 90.2667C21.3182 89.958 22.4341 90.0481 23.4153 90.5209C24.3989 90.9949 25.1647 91.8133 25.5718 92.8257L25.629 92.9872L35.6765 125.684L81.6385 112.265L77.2618 97.2744L85.6571 94.8234L91.2581 114.008C91.5854 115.129 91.4559 116.31 90.8936 117.334C90.3319 118.357 89.4054 119.1 88.2848 119.427ZM92.4861 130.141C91.3102 126.113 87.0917 123.801 83.0639 124.977C79.0362 126.153 76.7244 130.372 77.9003 134.399C79.0762 138.427 83.2947 140.739 87.3224 139.563C91.3502 138.388 93.662 134.169 92.4861 130.141ZM42.2238 136.901C38.196 138.076 35.8842 142.295 37.0601 146.323C38.236 150.35 42.4544 152.663 46.4822 151.487C50.51 150.311 52.8217 146.092 51.6458 142.064C50.4699 138.037 46.2515 135.725 42.2238 136.901ZM70.5924 81.9949L63.7547 78.9727L52.854 103.635L40.356 98.1104L37.3337 104.948L56.6693 113.495L70.5924 81.9949Z",
				fill: "#26CA99"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M110.238 24.7336L158.865 88.0583C163.462 94.0449 162.334 102.637 156.347 107.235L140.089 119.719L74.803 34.7009L91.0613 22.2161C97.0479 17.619 105.64 18.747 110.238 24.7336Z",
				fill: "#E88E43"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M137.405 121.78L72.1191 36.7617L68.7289 39.3651L134.015 124.384L137.405 121.78Z",
				fill: "#B6B7B6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189.546 47.7211C180.778 54.454 163.076 54.5202 144.723 63.0419L130.361 44.3398C143.219 29.1076 148.508 12.1265 157.128 5.50673C168.786 -3.44494 185.493 -1.2518 194.444 10.4053C203.396 22.0625 201.203 38.7692 189.546 47.7211Z",
				fill: "#E88E43"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5242_35467",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 151.795,
			fill: "white"
		})
	}) })]
});
export default SvgCartApprovedIcon;
